import { GeneralAction } from '../../../../../shared/infrastructure/store/actions/general_action';
import { DirectDebitActionTypes } from '../actions/actions';
import { DirectDebitState } from '../state/initialState';

const DirectDebitReducer = (state = DirectDebitState, actions: GeneralAction<DirectDebitActionTypes>) => {
    switch (actions.type) {
        /**
         * For getting all direct debits
         */
        case DirectDebitActionTypes.GET_ALL_DIRECT_DEBIT:
            return { ...state, directDebitLoading: true, directDebitError: null };
        case DirectDebitActionTypes.GET_ALL_DIRECT_DEBIT_SUCCESS:
            return { ...state, directDebitLoading: false, directDebitSuccess: true, allDirectDebit: actions.payload };
        case DirectDebitActionTypes.GET_ALL_DIRECT_DEBIT_FAILURE:
            return { ...state, directDebitLoading: false, directDebitFailure: true, directDebitError: actions.payload };

        /**
         * For getting single direct debit
         */
        case DirectDebitActionTypes.GET_SINGLE_DIRECT_DEBIT:
            return { ...state, singleDirectDebitLoading: true, singleDirectDebitError: null };
        case DirectDebitActionTypes.GET_SINGLE_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                singleDirectDebitLoading: false,
                singleDirectDebitSuccess: true,
                singleDirectDebit: actions.payload
            };
        case DirectDebitActionTypes.GET_SINGLE_DIRECT_DEBIT_FAILURE:
            return {
                ...state,
                singleDirectDebitError: actions.payload,
                singleDirectDebitFailure: true,
                singleDirectDebitLoading: false
            };

        /**
         * For Creating direct debit
         */
        case DirectDebitActionTypes.CREATE_DIRECT_DEBIT:
            return { ...state, createDirectDebitLoading: true, createDirectDebitError: null };
        case DirectDebitActionTypes.CREATE_DEIRECT_DEBIT_FAILURE:
            return {
                ...state,
                createDirectDebitError: actions.payload,
                createDirectDebitFailure: true,
                createDirectDebitLoading: false
            };
        case DirectDebitActionTypes.CREATE_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                createDirectDebitLoading: false,
                createDirectDebitSuccess: true,
                singleDirectDebit: actions.payload
            };

        /**
         * For sending direct debit
         */
        case DirectDebitActionTypes.SEND_DIRECT_DEBIT_DRAFT:
            return { ...state, sendDirectDebitLoading: true, sendDirectDebitError: null };
        case DirectDebitActionTypes.SEND_DIRECT_DEBIT_DRAFT_SUCCESS:
            return { ...state, sendDirectDebitLoading: false, sendDirectDebitSuccess: true };
        case DirectDebitActionTypes.SEND_DIRECT_DEBIT_DRAFT_FAILURE:
            return {
                ...state,
                sendDirectDebitLoading: false,
                sendDirectDebitFailure: true,
                sendDirectDebitError: actions.payload
            };

        /**
         * For editing direct debit
         */

        case DirectDebitActionTypes.EDIT_DIRECT_DEBIT_LOADING:
            return {
                ...state,
                editDirectDebitLoading: true,
                editDirectDebitError: null,
                editDirectDebitFailure: false
            };

        case DirectDebitActionTypes.EDIT_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                editDirectDebitSuccess: true,
                singleDirectDebit: actions.payload,
                editDirectDebitLoading: false
            };

        case DirectDebitActionTypes.EDIT_DIRECT_DEBIT_FAILURE:
            return {
                ...state,
                editDirectDebitFailure: true,
                editDirectDebitLoading: false,
                editDirecDebitError: actions.payload
            };

        /**
         * For deleting direct debit
         */

        case DirectDebitActionTypes.DELETE_DIRECT_DEBIT_LOADING:
            return {
                ...state,
                deleteDirectDebitLoading: true,
                deleteDirectDebitFailure: false,
                deleteDirectDebitError: null
            };
        case DirectDebitActionTypes.DELETE_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                deleteDirectDebitLoading: false,
                deleteDirectDebitSuccess: true,
                deleteDirectDebitMessage: actions.payload
            };

        case DirectDebitActionTypes.DELETE_DIRECT_DEBIT_FAILURE:
            return {
                ...state,
                deleteDirectDebitLoading: false,
                deleteDirectDebitFailure: true,
                deleteDirectDebitError: actions.payload
            };

        /**
         * clearing direct debit states
         */
        case DirectDebitActionTypes.CLEAR_DIRECT_DEBIT_ERROR:
            return {
                ...state,
                directDebitError: null,
                singleDirectDebitError: null,
                directDebitFailure: false,
                singleDirectDebitFailure: false,
                sendDirectDebitError: null,
                editDirectDebitError: null,
                deletDirectDebitError: null,
                deleteDirectDebitFailure: false,
                editDirectDebitFailure: false,
                directDebitStatusError: null,
                directDebitStatusFailure: false,
                scheduleCustomerDebitFailure: false,
                scheduleCustomerDebitError: null
            };
        case DirectDebitActionTypes.CLEAR_DIRECT_DEBIT_LOADING:
            return {
                ...state,
                directDebitLoading: false,
                singleDirectDebitLoading: false,
                sendDirectDebitLoading: false,
                editDirectDebitLoading: false,
                deleteDirectDebitLoading: false
            };
        case DirectDebitActionTypes.CLEAR_DIRECT_DEBIT_SUCCESS:
            return {
                ...state,
                sendDirectDebitSuccess: false,
                editDirectDebitSuccess: false,
                deleteDirectDebitSuccess: false,
                directDebitStatusSuccess: false,
                scheduleCustomerDebitSuccess: false
            };

        /**
         * Requesting Direct Debit Status
         */
        case DirectDebitActionTypes.GET_DIRECT_DEBIT_STATUS:
            return {
                ...state,
                directDebitStatusLoading: true,
                directDebitStatusError: null,
                directDebitStatusFailure: false
            };
        case DirectDebitActionTypes.GET_DIRECT_DEBIT_STATUS_FAILURE:
            return {
                ...state,
                directDebitStatusLoading: false,
                directDebitStatusError: actions.payload,
                directDebitStatusFailure: true
            };
        case DirectDebitActionTypes.GET_DIRECT_DEBIT_STATUS_SUCCESS:
            return {
                ...state,
                directDebitStatusSuccess: true,
                directDebitStatusData: actions.payload,
                directDebitStatusLoading: false
            };

        /**
         * Schedule Customer Debit
         */
        case DirectDebitActionTypes.SCHEDULE_CUSTOMER_DEBIT:
            return {
                ...state,
                scheduleCustomerDebitFailure: false,
                scheduleCustomerDebitError: null,
                scheduleCustomerDebitLoading: true,
                scheduleCustomerDebitMessage: null,
                scheduleCustomerDebitSuccess: false
            };
        case DirectDebitActionTypes.SCHEDULE_CUSTOMER_DEBIT_FAILURE:
            return {
                ...state,
                scheduleCustomerDebitFailure: true,
                scheduleCustomerDebitError: actions.payload,
                scheduleCustomerDebitLoading: false,
                scheduleCustomerDebitMessage: null,
                scheduleCustomerDebitSuccess: false
            };
        case DirectDebitActionTypes.SCHEDULE_CUSTOMER_DEBIT_SUCCESS:
            return {
                ...state,
                scheduleCustomerDebitFailure: false,
                scheduleCustomerDebitError: null,
                scheduleCustomerDebitLoading: false,
                scheduleCustomerDebitMessage: actions.payload,
                scheduleCustomerDebitSuccess: true
            };
        case DirectDebitActionTypes.GET_DIRECT_DEBIT_TRANSACTIONS:
            return {
                ...state,
                directDebitTransactionsSuccess: false,
                directDebitTransactionsLoading: true,
                // directDebitTransactions: {} as ,
                directDebitTransactionsFailure: false
            };

        case DirectDebitActionTypes.GET_DIRECT_DEBIT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                directDebitTransactionsSuccess: true,
                directDebitTransactionsLoading: false,
                directDebitTransactions: actions.payload,
                directDebitTransactionsFailure: false
            };

        case DirectDebitActionTypes.GET_DIRECT_DEBIT_TRANSACTIONS_FAILURE:
            return {
                ...state,
                directDebitTransactionsSuccess: false,
                directDebitTransactionsLoading: false,
                directDebitTransactionsFailure: true
            };
            case DirectDebitActionTypes.CANCEL_SUBSCRIPTION:
                return {
                    ...state,
                    cancelDirectDebit: true,
                    cancelDirectDebitFailure: false,
                    cancelDirectDebitSuccess: false
                };
    
            case DirectDebitActionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
                return {
                    ...state,
                    cancelDirectDebit: false,
                    cancelDirectDebitFailure: false,
                    cancelDirectDebitSuccess: true
                };
    
            case DirectDebitActionTypes.CANCEL_SUBSCRIPTION_FAILURE:
                return {
                    ...state,
                    cancelDirectDebit: false,
                    cancelDirectDebitFailure: true,
                    cancelDirectDebitSuccess: false
                };
                case DirectDebitActionTypes.CLEAR_DIRECT_DEBIT_STATE:
                    return {
                        ...state,
                        cancelDirectDebit: false,
                        cancelDirectDebitFailure: false,
                        cancelDirectDebitSuccess: false
                    };
        default:
            return state;
    }
};

export default DirectDebitReducer;
